// src/components/TiendaRecompensas.js

import React from 'react';
import Card from './Card';
import Button from './Button';
import { FaLock } from 'react-icons/fa';

function TiendaRecompensas({ recompensas, puntos, onCanjearRecompensa }) {
  return (
    <div>
      <h2 className="text-3xl font-bold text-gray-700 mb-6">Premios Mágicos</h2>
      <div className="space-y-4">
        {recompensas.length > 0 ? (
          recompensas.map(recompensa => {
            const puedeCanjear = puntos >= recompensa.puntos_necesarios;
            return (
              <Card key={recompensa.id} className={`flex items-center justify-between transition-opacity ${!puedeCanjear && 'opacity-60'}`}>
                <div>
                  <p className="font-bold text-xl">{recompensa.titulo}</p>
                  <p className="text-acento font-semibold text-lg">{recompensa.puntos_necesarios} Puntos</p>
                </div>
                <Button 
                  variant="accent" 
                  onClick={() => onCanjearRecompensa(recompensa)} 
                  disabled={!puedeCanjear}
                  className="w-32"
                >
                  {puedeCanjear ? 'Canjear' : <FaLock />}
                </Button>
              </Card>
            )
          })
        ) : (
          <Card>
            <p className="text-gray-500 text-center py-4">Tus padres aún no han añadido ninguna recompensa. ¡Pídeles que creen algunos premios!</p>
          </Card>
        )}
      </div>
    </div>
  );
}

export default TiendaRecompensas;